import axios from "axios";

const lms_v2_api = axios.create({
    baseURL: process.env.REACT_APP_LMS_V2_API || "https://api-v2.dev99lms.com",
    //local
    // baseURL: "http://127.0.0.1:7000",
    headers: {
      "cs-application-type": "web-login",
      "cs-app-version": "v1",
      "Content-Type": "application/json",
    },
  });
const lms_login_service_api = axios.create({
    baseURL: process.env.REACT_APP_LMS_LOGIN_API || "https://identity-service.dev99lms.com",
    //local
    // baseURL: "http://127.0.0.1:5000",
    headers: {
      "cs-application-type": "web-login",
      "cs-app-version": "v1",
      "Content-Type": "application/json",
    },
  });

  const faceLoginEndPoint = process.env.REACT_APP_FACE_LOGIN_ENDPOINT || "https://srhu2kq619.execute-api.ap-south-1.amazonaws.com/dev/users"


  const global_var = {
    lmsClientUrl: process.env.REACT_APP_LMS_CLIENT_URL || "https://*.dev99lms.com/",
    domain: process.env.REACT_APP_DOMAIN_NAME || ".dev99lms.com"
  }

  const google_redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URI || "https://cs.login.cybersquare.org/google_sign"

  const getMsalConfig = () => ({
    auth: {
      clientId: global_var.loginPageConf?.azureAdConf?.clientId || '',
      authority: global_var.loginPageConf?.azureAdConf?.authority || 'https://login.microsoftonline.com/common',
      redirectUri: global_var.loginPageConf?.azureAdConf?.redirectUri || window.location.origin + '/login'
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    },
    system: {
      allowNativeBroker: false
    }
  });
  
  export { lms_v2_api, global_var, lms_login_service_api, google_redirectUri, faceLoginEndPoint, getMsalConfig };